import { toDate as o } from "./toDate.js";
import { constructFrom as a } from "./constructFrom.js";
function s(e, r) {
  const t = o(e);
  return isNaN(r) ? a(e, NaN) : (r && t.setDate(t.getDate() + r), t);
}
export {
  s as addDays,
  s as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/addDays.js
// module id = 443
// module chunks = 67